export const QA_NAME_LISTING_PUBLICATION_ERROR_MODAL =
  'listingPublicationErrorModal'
